/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Box, Button, useTheme} from '@salesforce/retail-react-app/app/components/shared/ui'
import usePostalCodeFields from './usePostalCodeFields'
import Field from '../field'

const PostalCodeFields = ({form, prefix = '', ...props}) => {
    const fields = usePostalCodeFields({form, prefix})
    const theme = useTheme()

    const postalCode = form.watch('postalCode')

    return (
        <Box aria-labelledby="code-feedback" {...props}>
            <Field inputProps={theme.components.Input.baseStyle.field} {...fields.postalCode}>
                <Button
                    variant={'link'}
                    type="submit"
                    fontSize="xs"
                    position="absolute"
                    right="0"
                    top="0"
                    margin="auto"
                    height="100%"
                    isLoading={form.formState.isSubmitting}
                    disabled={postalCode?.length < 3}
                >
                    <FormattedMessage defaultMessage="Apply" id="promo_code_fields.button.apply" />
                </Button>
            </Field>
        </Box>
    )
}

PostalCodeFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string
}

export default PostalCodeFields
